import url from './url/journal.js'
import http from '@/utils/request'
// 获取日志列表
export const getBehaviorList = (data) => http.post(url.getBehaviorList,data)
//日志导出
export const getBehaviorExport = (data) => http.post(url.getBehaviorList,data)
//用户列表
export const getUserList = (data) => http.post(url.getUserList,data)